export default {
  metadata: {
    name: 'JDSContainer',
    version: '0.0.1'
  },
  hierarchy: {
    container: ['content-slot']
  },
  base: {
    container: {
      'background-color': '{global.transparent}',
      'flex-direction': '{flexDirection.row}',
      'justify-content': '{justifyContent.start}',
      'align-items': '{alignItems.start}',
      'padding-left': 0,
      'padding-top': 0,
      'padding-bottom': 0,
      'padding-right': 0,
      'border-bottom-width': 0,
      'border-top-width': 0,
      'border-right-width': 0,
      'border-left-width': 0
    }
  },
  variant: {
    direction: {
      column: {
        container: {
          'flex-direction': '{flexDirection.column}'
        }
      },
      stack: {
        container: {
          'flex-direction': '{flexDirection.stack}'
        }
      }
    }
  },
  combination: [
    {
      row: {
        center: {
          container: {
            'align-items': '{alignItems.center}'
          }
        },
        end: {
          container: {
            'align-items': '{alignItems.end}'
          }
        },
        'space-between': {
          container: {
            'align-items': '{alignItems.spaceBetween}'
          }
        },
        'space-around': {
          container: {
            'align-items': '{alignItems.spaceAround}'
          }
        },
        'space-evenly': {
          container: {
            'align-items': '{alignItems.spaceEvenly}'
          }
        }
      },
      column: {
        center: {
          container: {
            'justify-content': '{justifyContent.center}'
          }
        },
        end: {
          container: {
            'justify-content': '{justifyContent.end}'
          }
        },
        'space-between': {
          container: {
            'justify-content': '{justifyContent.spaceBetween}'
          }
        },
        'space-around': {
          container: {
            'justify-content': '{justifyContent.spaceAround}'
          }
        },
        'space-evenly': {
          container: {
            'justify-content': '{justifyContent.spaceEvenly}'
          }
        }
      },
      stack: {
        center: {
          container: {
            'align-items': '{alignItems.center}'
          }
        },
        end: {
          container: {
            'align-items': '{alignItems.end}'
          }
        }
      }
    },
    {
      row: {
        center: {
          container: {
            'justify-content': '{justifyContent.center}'
          }
        },
        end: {
          container: {
            'justify-content': '{justifyContent.end}'
          }
        },
        'space-between': {
          container: {
            'justify-content': '{justifyContent.spaceBetween}'
          }
        },
        'space-around': {
          container: {
            'justify-content': '{justifyContent.spaceAround}'
          }
        },
        'space-evenly': {
          container: {
            'justify-content': '{justifyContent.spaceEvenly}'
          }
        }
      },
      column: {
        center: {
          container: {
            'align-items': '{alignItems.center}'
          }
        },
        end: {
          container: {
            'align-items': '{alignItems.end}'
          }
        },
        'space-between': {
          container: {
            'align-items': '{alignItems.spaceBetween}'
          }
        },
        'space-around': {
          container: {
            'align-items': '{alignItems.spaceAround}'
          }
        },
        'space-evenly': {
          container: {
            'align-items': '{alignItems.spaceEvenly}'
          }
        }
      },
      stack: {
        center: {
          container: {
            'justify-content': '{justifyContent.center}'
          }
        },
        end: {
          container: {
            'justify-content': '{justifyContent.end}'
          }
        }
      }
    }
  ],
  combination_config: [
    ['direction', 'verticalAlign'],
    ['direction', 'horizontalAlign']
  ],
  api: {
    children: {
      'content-slot': {
        name: 'children',
        accepts: ['any']
      }
    },
    config: {
      verticalAlign: {
        values: [
          'start',
          'center',
          'end',
          'space-between',
          'space-around',
          'space-evenly'
        ]
      },
      horizontalAlign: {
        values: [
          'start',
          'center',
          'end',
          'space-between',
          'space-around',
          'space-evenly'
        ]
      },
      direction: {
        values: ['row', 'column', 'stack']
      }
    },
    data: {
      container: {
        width: {
          type: 'size',
          name: 'width'
        },
        height: {
          type: 'size',
          name: 'height'
        },
        'background-color': {
          type: 'string',
          name: 'backgroundColor'
        },
        'border-radius': {
          type: 'size',
          name: 'radius'
        },
        'padding-left': {
          type: 'size',
          name: 'paddingLeft'
        },
        'padding-right': {
          type: 'size',
          name: 'paddingRight'
        },
        'padding-top': {
          type: 'size',
          name: 'paddingTop'
        },
        'padding-bottom': {
          type: 'size',
          name: 'paddingBottom'
        },
        flex: {
          type: 'number',
          name: 'flex'
        },
        'border-left-width': {
          type: 'size',
          name: 'borderLeftWidth'
        },
        'border-right-width': {
          type: 'size',
          name: 'borderRightWidth'
        },
        'border-top-width': {
          type: 'size',
          name: 'borderTopWidth'
        },
        'border-bottom-width': {
          type: 'size',
          name: 'borderBottomWidth'
        },
        'border-color': {
          type: 'string',
          name: 'borderColor'
        },
        gap: {
          type: 'size',
          name: 'gap'
        },
        overflow: {
          type: 'string',
          name: 'overflow',
          platform: 'web'
        }
      }
    }
  }
};
